<template>
  <header class="header">
    <div class="header__main">
      <div class="header__title" @click="handleHomeClick">
        <div v-if="notMainPage" class="header__title__back">
          <el-icon :size="20" color="#199eda">
            <ArrowLeftBold />
          </el-icon>
        </div>
        <div v-if="notMainPage" class="header__divider header__divider__logo" />
        <svg width="194" height="40">
          <use xlink:href="#icon-logo" />
        </svg>
      </div>
      <div v-if="currPage" class="header__divider" />
      <div v-if="currPage" class="header__page">
        <div class="header__page__name">
          {{ currPage.label }}
        </div>
        <div v-if="currPage.withIndex && !isClassifierPage" class="header__page__subname">
          {{ currDocData.index || currDocData['index_name'] }}
        </div>
        <div v-if="currPage.withIndex && isClassifierPage" class="header__page__subname">
          {{ `${currRootClassifier.name} (id:${currRootClassifier.id})` }}
        </div>
      </div>
    </div>
    <div v-if="isLogin" class="header__user">
      <el-dropdown trigger="click">
        <button class="header__user_button">
          <svg width="16" height="16">
            <use xlink:href="#icon-user" />
          </svg>
        </button>
        <template #dropdown>
          <div class="user">
            <div class="user__name">
              {{ currEditor.name || 'Пользователь' }}
            </div>
            <div class="user__email">
              {{ currEditor.email }}
            </div>
          </div>
          <el-dropdown-menu style="width: 250px">
            <el-dropdown-item>
              <a href="https://profile.dev.normacs.info/" class="user__settings" target="_blank">
                <svg width="13" height="14">
                  <use xlink:href="#icon-settings" />
                </svg>
                <span>Настройки</span>
              </a>
            </el-dropdown-item>
            <el-dropdown-item @click="handleLogOut">
              <div class="user__logout">
                <svg width="12" height="12">
                  <use xlink:href="#icon-logout" />
                </svg>
                <span>Выйти</span>
              </div>
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </div>
  </header>
</template>

<script>
import { mapGetters } from 'vuex';
import { PAGES_DICTIONARY } from '@/utils/configs/dictionaryCommons';

export default {
  computed: {
    ...mapGetters(['currEditor', 'currDocData', 'currRootClassifier']),

    isLogin() {
      return !!this.currEditor;
    },

    currPage() {
      return PAGES_DICTIONARY[this.$route.name];
    },

    notMainPage() {
      return this.$route.name !== 'Login' && this.$route.name !== 'Home';
    },

    isClassifierPage() {
      return this.$route.name.includes('Classifier');
    },
  },

  methods: {
    async handleHomeClick() {
      switch (this.$route.name) {
        case 'Cleanup':
          if (this.currDocData.id) {
            await this.$store.dispatch('deleteDoc', this.currDocData.id);
          }
          this.$store.dispatch('setProjectStyles', null);
          break;
        case 'Create':
          this.$store.dispatch('setFileName', '');
          await this.$store.dispatch('deleteCurrSpec');
          this.$store.dispatch('resetCurrentSpecData');
          break;
        case 'Update':
          this.handleClearUpdates();
          break;
        default:
          console.error('Go to Home!', this.$route.name);
          break;
      }
      this.$router.push({ name: 'Home' });
    },

    handleLogOut() {
      this.$store.dispatch('setSessionEditor', null);
      localStorage.removeItem('session-nrm-spec');
      this.$router.push({ name: 'Login' });
    },

    handleClearUpdates() {
      this.$store.commit('SET_VERIFIED_REQ_FEATURES', {
        action: 'clear',
        params: [],
      });
      this.$store.commit('SET_NOT_DEFINED_CODES', {
        action: 'clear',
        params: [],
      });
      this.$store.commit('SET_VERIFIED_REQ_CLASSES', {
        action: 'clear',
        params: [],
      });
      this.$store.commit('SET_VERIFIED_REQS', []);
    },
  },
};
</script>

<style scoped>
.header {
  height: 64px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 24px;
  border-bottom: 1px solid #ccd4db;
}

.header__main {
  display: flex;
  align-items: center;
  gap: 20px;
  height: 100%;
}

.header__divider {
  background-color: #199eda;
  height: 40px;
  width: 1px;
}

.header__divider__logo {
  width: 0px;
  height: 0px;
  margin-right: 0px;
  transition: all 0.5s ease;
}

.header__page {
  display: flex;
  flex-direction: column;
  justify-items: center;
  align-items: flex-start;
}

.header__page__name {
  color: #199eda;
}

.header__title {
  cursor: pointer;
  display: flex;
  align-items: center;
}

.header__title__back {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  color: #199eda;
  width: 0px;
  overflow: hidden;
  text-wrap: nowrap;
  transition: width 0.5s ease;
}

.header__user {
  height: 40px;
  width: 40px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  cursor: pointer;
}

.header__user_button {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background-color: #199eda;
  border: none;
  transition: all 0.3s ease;
  cursor: pointer;
}

.user__settings,
.user__logout {
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 10px;
  font-family: Roboto, Arial, sans-serif;
  font-weight: 500;
}

.user__settings {
  color: #202530;
}

.user__logout {
  color: #db717a;
}

.user {
  width: 250px;
  padding: 10px 16px;
  border-bottom: 1px solid #ccd4db;
}

.user__name {
  font-weight: 700;
  font-size: 14px;
}

.user__email {
  font-size: 12px;
  color: gray;
}

.user__name,
.user__email {
  font-family: Roboto, Arial, sans-serif;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

@media (hover: hover) {
  .header__user:hover {
    background-color: #e8f6fc;
  }

  .header__title:hover .header__title__back {
    width: 35px;
  }

  .header__title:hover .header__divider__logo {
    width: 1px;
    height: 40px;
    margin-right: 20px;
  }
}
</style>
